import useRefinementStore from "@/use-refinement-store";
import React, { FunctionComponent } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

const ShowGeolocator: FunctionComponent<ShowGeolocatorProps> = ({
  onClick,
}) => {
  const name = useRefinementStore((store) => store.name);

  return (
    <button
      onClick={onClick}
      className="tw-border tw-rounded-full tw-p-1 tw-px-3 tw-w-max tw-bg-gray-600 tw-text-white tw-font-button"
    >
      <FontAwesomeIcon icon={faXmark} className="tw-inline" /> {name}
    </button>
  );
};

export type ShowGeolocatorProps = {
  onClick: VoidFunction;
};

export default React.memo(ShowGeolocator);
